import React, { Fragment } from 'react'
import {
  FaCamera,
  FaClone,
  FaCrop,
  FaImage,
  FaImages,
  FaObjectGroup,
  FaObjectUngroup,
  FaQrcode,
  FaSync,
  FaTrash,
  FaWindowMaximize,
} from 'react-icons/fa'
import 'react-resizable/css/styles.css'
import { Tab, TabList, TabPanel, Tabs } from '../../components/Tabs'
import CollectionColors from '../../containers/CollectionColors'
import CollectionFrames from '../../containers/CollectionFrames'
import CollectionPhotos from '../../containers/CollectionPhotos'
import CollectionProducts from '../../containers/CollectionProducts'
import CollectionProductsSets from '../../containers/CollectionProductsSets'
import CollectionWallpapers from '../../containers/CollectionWallpapers'
import CropImage from '../../containers/CropImage'
import DesignedCanvas from '../../containers/DesignedCanvas'
import {
  Copy,
  Crop,
  FrameMenuForFrames,
  FrameMenuForSets,
  Remove,
  Resize,
  Rotate,
  SelectFrame,
  SelectPhoto,
  Split,
  MergeSet,
} from '../../containers/FrameMenu'
import FrameSettings from '../../containers/FrameSettings'
import MeasureBackground from '../../containers/MeasureBackground'
import { FrameItem, PhotosItem, ProductItem, WallpapersItem } from '../../containers/NavigationItem'
import PhotosFiltering from '../../containers/PhotosFiltering'
import PreviewFrame from '../../containers/PreviewFrame'
import Sidebar from '../../containers/Sidebar'
import WallBackground from '../../containers/WallBackground'
import SavingBackground from '../../components/SavingBackground'

export default () => (
  <Fragment>
    <Sidebar>
      <WallpapersItem title={'Wybierz ścianę'} icon={FaImages}>
        <CollectionWallpapers onlySystem={false} withUpload={true} title={'Ściany użytkownika'} />
        <CollectionWallpapers onlySystem={true} withUpload={false} title={'Biblioteka ścian'} />
      </WallpapersItem>
      <ProductItem title={'Dodaj foto-obrazy'} icon={FaObjectUngroup} withoutPadding={true}>
        <Tabs>
          <TabList style={{ marginBottom: '20px' }}>
            <Tab>Szablony</Tab>
            <Tab>Pojedyncze wallarty</Tab>
          </TabList>
          <TabPanel>
            <CollectionProductsSets />
          </TabPanel>
          <TabPanel>
            <CollectionProducts />
          </TabPanel>
        </Tabs>
      </ProductItem>
      <PhotosItem title={'Wybierz zdjęcia'} icon={FaCamera}>
        {/*<PhotosFiltering /> PRIN-295*/}
        <CollectionPhotos withUpload={true} />
      </PhotosItem>
      <FrameItem title={'Wybierz linię produktów'} icon={FaObjectGroup}>
        <CollectionFrames title={'Obramowanie'} />
        <CollectionColors title={'Kolor obramowania'} />
      </FrameItem>
    </Sidebar>
    <CropImage />
    <SavingBackground />
    <WallBackground>
      <FrameSettings />
      <DesignedCanvas />
      <FrameMenuForFrames>
        <SelectPhoto icon={FaImage}>Wybierz zdjęcie</SelectPhoto>
        <SelectFrame icon={FaObjectGroup}>Wybierz obramowanie</SelectFrame>
        <Resize icon={FaWindowMaximize}>Zmień rozmiar</Resize>
        <Rotate icon={FaSync}>Obróc</Rotate>
        <Copy icon={FaClone}>Duplikuj</Copy>
        <Crop typeOf={'picture'} icon={FaCrop}>
          Kadruj
        </Crop>
        {/*<MergeSet icon={FaQrcode}>Przywróć szablon</MergeSet>*/}
        <Remove icon={FaTrash}>Usuń</Remove>
      </FrameMenuForFrames>
      <FrameMenuForSets>
        <Split icon={FaQrcode}>Rozdziel</Split>
        <Remove icon={FaTrash}>Usuń</Remove>
      </FrameMenuForSets>
    </WallBackground>
    <PreviewFrame isOpen={true} />
  </Fragment>
)



// WEBPACK FOOTER //
// ./src/screens/Creator/struct.js